import React from 'react';
import { Globe, Linkedin, Github, ArrowLeft, Heart, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ThemeChanger from '../Components/ThemeChanger';

export default function CreatedBy() {
  const navigate = useNavigate();

  const socialLinks = [
    {
      name: "Portfolio",
      icon: Globe,
      url: "https://ashwinsi.in",
      color: "from-blue-500 to-cyan-500",
      bgColor: "bg-blue-500/10 hover:bg-blue-500/20",
    },
    {
      name: "LinkedIn",
      icon: Linkedin,
      url: "https://www.linkedin.com/in/ashwinsi",
      color: "from-blue-600 to-blue-400",
      bgColor: "bg-blue-600/10 hover:bg-blue-600/20",
    },
    {
      name: "GitHub",
      icon: Github,
      url: "https://github.com/ashwinn-si",
      color: "from-gray-600 to-gray-400",
      bgColor: "bg-gray-600/10 hover:bg-gray-600/20",
    },
  ];

  return (
    <div className="min-h-screen bg-base-200 flex flex-col">
      {/* Header */}
      <div className="navbar bg-base-100 shadow-md px-4 sm:px-6 lg:px-8">
        <div className="flex-1">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-ghost btn-sm gap-2"
          >
            <ArrowLeft size={20} />
            Back
          </button>
        </div>
        <div className="flex-none">
          <ThemeChanger />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="max-w-2xl w-full">
          {/* Profile Card */}
          <div className="card bg-base-100 shadow-xl">
            <div className="card-body items-center text-center">
              {/* Profile Image */}
              <div className="avatar mb-6">
                <div className="w-32 h-32 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2 bg-gradient-to-r from-primary to-secondary flex items-center justify-center">
                  <User size={64} className="text-white" />
                </div>
              </div>

              {/* Name and Title */}
              <h1 className="text-3xl sm:text-4xl font-bold text-base-content mb-2">
                Ashwin S I
              </h1>
              <p className="text-base-content/70 text-lg mb-2">
                Full Stack Developer
              </p>
              <div className="flex items-center gap-2 text-base-content/60 mb-6">
                <Heart size={16} className="text-red-500" />
                <span>Creator of PathFinder</span>
              </div>

              {/* Description */}
              <p className="text-base-content/80 max-w-md mb-8">
                Passionate about building products that help people learn and grow.
                PathFinder is my vision to make personalized learning accessible to everyone.
              </p>

              {/* Social Links */}
              <div className="w-full">
                <h2 className="text-xl font-semibold text-base-content mb-4">
                  Connect with me
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  {socialLinks.map((social) => {
                    const IconComponent = social.icon;
                    return (
                      <a
                        key={social.name}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`card ${social.bgColor} border border-base-300 transition-all duration-300 hover:scale-105 cursor-pointer`}
                      >
                        <div className="card-body items-center text-center p-6">
                          <div className={`w-12 h-12 rounded-full bg-gradient-to-r ${social.color} flex items-center justify-center mb-3`}>
                            <IconComponent size={24} className="text-white" />
                          </div>
                          <h3 className="font-semibold text-base-content">
                            {social.name}
                          </h3>
                        </div>
                      </a>
                    );
                  })}
                </div>
              </div>

              {/* Call to Action */}
              <div className="mt-8">
                <button
                  onClick={() => navigate('/')}
                  className="btn btn-primary btn-wide"
                >
                  Explore PathFinder
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="py-4 text-center text-base-content/60 text-sm">
        © {new Date().getFullYear()} PathFinder. All rights reserved.
      </div>
    </div>
  );
}
